module.exports = __webpack_public_path__ + "img/LightSpeakerWhite.7038ea66.png";